import { render, staticRenderFns } from "./Population.vue?vue&type=template&id=5052493c"
import script from "./Population.vue?vue&type=script&lang=js"
export * from "./Population.vue?vue&type=script&lang=js"
import style0 from "./Population.vue?vue&type=style&index=0&id=5052493c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports